import AllProducts from './AllProducts';

export default AllProducts;
